import { css } from 'styled-components';

export const modalHeadingStyles = css`
  margin-top: 0;
`;
